export default import.meta.ROLLDOWN_FILE_URL_f398U_GNpmcYtwxxT94vqQ